<template>
  <div class="order-detail-container">
    <div class="row">
      <div class="col-md-12">
        <b-button
          :title="textButtonSetting"
          @click="visibleSetting = !visibleSetting"
          aria-controls="table-setting-order-container"
          class="mb-2 pull-right"
          variant="light">
          <i class="fa fa-cog"></i>
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-collapse v-model="visibleSetting" id="table-setting-order-container">
          <b-card class="card-fields">
            <b-form-group label="Table Fields">
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="checkedFields"
                :options="optionFields"
                name="field-options"
                stacked
              ></b-form-checkbox-group>
            </b-form-group>
          </b-card>
        </b-collapse>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div v-show="loadingState" class="loading-saving-container fadeIn">
          <p>{{ loadingText }}</p>
        </div>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="thead-light">
              <tr>
                <th v-for="field in tableFields" :key="field.key" v-show="checkShowField(field)">
                  {{ field.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in tableData" :key="data">
                <td v-for="field in tableFields" :key="field.key" v-show="checkShowField(field)">
                  <div style="min-width: 47px;" class="order_item--action" v-if="field.key === 'action'">
                    <span @click="onClickIconMove(data)">
                      <i title="Move to other shipment" class="fa fa-exchange"></i>
                    </span>
                    <router-link :to="`/shipment_md/orders/${data.order_id}/edit`">
                      <i title="Edit" class="fa fa-pencil-square-o"></i>
                    </router-link>
                    <span @click="onClickDeleteOrder(data)" style="color: #DC3545;" title="Delete">
                      <i class="fa fa-trash-o"></i>
                    </span>
                  </div>
                  <span v-else-if="field.key === 'customer_code'">
                    {{ formatCustomerCode(data, field.key) }}
                  </span>
                  <span v-else>{{ get(data, field.key) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, has, debounce, isEmpty } from 'lodash';
import localforage from 'localforage';

export default {
  name: 'OrderDetailsTable',
  props: {
    forceHideFieldAction: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Array,
      require: true,
    },
    keySetting: {
      type: String,
      default: 'order_detail_table',
    },
    tableFields: {
      type: Array,
      default: [
        {
          title: 'Sequence',
          key: 'sequence',
          show: true,
        },
        {
          title: 'Number',
          key: 'number',
          show: true,
          disable: true,
        },
        {
          title: 'Customer Code',
          key: 'customer_code',
          show: true,
        },
        {
          title: 'Customer Name',
          key: 'customer_name',
          show: true,
        },
        {
          title: 'Customer Address',
          key: 'customer_address',
          show: true,
        },
        {
          title: 'Company',
          key: 'company',
          show: false,
        },
        {
          title: 'Segment',
          key: 'segment',
          show: true,
        },
        {
          title: 'Storage Type',
          key: 'storage_type',
          show: true,
        },
        {
          title: 'Truck Type',
          key: 'truck_type',
          show: true,
        },
        {
          title: 'Code Route',
          key: 'code_route',
          show: true,
        },
        {
          title: 'Total Gross Volume',
          key: 'volume',
          show: true,
        },
        {
          title: 'Total Gross Weight',
          key: 'weight',
          show: true,
        },
        {
          title: 'Total QTY',
          key: 'total_qty',
          show: true,
        },
        {
          title: 'Action',
          key: 'action',
          show: true,
          disable: true,
        },
      ],
    },
  },
  watch: {
    checkedFields: debounce(function checkedFields(data) {
      this.tableFields = this.tableFields.map((dt) => {
        dt.show = data.includes(dt.key);
        return dt;
      });

      if (this.isInitialAssignValue) return;

      this.setLoadingState(true, 'Saving...');
      this.saveSetting(this.tableFields).then(() => {
        setTimeout(() => {
          this.setLoadingState(false);
        }, 2e3);
      });
    }, 1e3),
    visibleSetting(show) {
      this.textButtonSetting = show ? 'Hide Table Setting' : 'Show Table Setting';
    },
  },
  created() {
    localforage.getItem(this.keySetting).then((data) => {
      const fields = !isEmpty(data) ? data : this.tableFields;
      this.isInitialAssignValue = true;
      this.checkedFields = fields
        .filter(dt => dt.show)
        .map(dt => dt.key);
      this.optionFields = this.tableFields
        .map(dt => (
          {
            text: dt.title,
            value: dt.key,
            disabled: has(dt, 'disable') ? dt.disable : false,
          }
        ));
      setTimeout(() => {
        this.isInitialAssignValue = false;
      }, 3e3);
    });
  },
  data() {
    return {
      checkedFields: [],
      optionFields: [],
      visibleSetting: false,
      textButtonSetting: 'Show Table Setting',
      loadingText: 'Saving...',
      loadingState: false,
      isInitialAssignValue: false,
    };
  },
  methods: {
    get(object, key) {
      return get(object, key) || '';
    },
    checkShowField(field) {
      if (field.key === 'action' && this.forceHideFieldAction) {
        return false;
      }
      return field.show;
    },
    setLoadingState(show, text = '') {
      this.loadingState = show;
      this.loadingText = text;
    },
    loadUserPreferences() {
      return this.$store.dispatch('users/LOAD_USER_PREFERENCES');
    },
    saveSetting(value = []) {
      return localforage.setItem(this.keySetting, value);
    },
    onClickIconMove(data) {
      this.$emit('on-move-order', data);
    },
    onClickDeleteOrder(data) {
      this.$emit('on-delete-order', data);
    },
    formatCustomerCode(data, key) {
      const value = this.get(data, key);
      return value.replace('PRB-', '');
    },
  },
};
</script>

<style lang="sass" scoped>
  .order_item--action
    cursor: pointer;

  .card-fields > .card-body
    max-height: 200px;
    overflow-y: auto;
    padding: 10px;

  .card-fields
    margin-bottom: 10px;

  .loading-saving-container > p
    margin-bottom: 0px;
    text-align: center;
    background: #F9EDBE;
    border: 1px solid #f0c36d;
    font-weight: bold;

  .loading-saving-container
    padding: 5px;
</style>



// WEBPACK FOOTER //
// src/components/OrderDetailsTable.vue